module.exports = __webpack_public_path__ + "img/heading_uk.f3184ca3.svg";